module.exports = __webpack_public_path__ + "img/logo.5f73b3f2.png";